/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadIdsDto } from '../../models/lexplus-upload-ids-dto';
import { LexplusUploadMiniDto } from '../../models/lexplus-upload-mini-dto';

export interface ErlassDetailControllerLinkErlassDokumenteV1$Params {
  erlassID: number;
      body: LexplusUploadIdsDto
}

export function erlassDetailControllerLinkErlassDokumenteV1(http: HttpClient, rootUrl: string, params: ErlassDetailControllerLinkErlassDokumenteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusUploadMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, erlassDetailControllerLinkErlassDokumenteV1.PATH, 'post');
  if (params) {
    rb.path('erlassID', params.erlassID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusUploadMiniDto>>;
    })
  );
}

erlassDetailControllerLinkErlassDokumenteV1.PATH = '/v1/compliance/erlasse/{erlassID}/dokumente';
